import EDocumentStatusOffCanvas, { EDocumentStatusProps, EDocumentStatusReference } from "@components/layout/Offcanvas/EDocumentStatusOffCanvas";
import { parseEDocumentStatusPayload, resolveEDocumentAtvStatus } from "@utils/edocumentAtvStatus";
import { ReactNode } from "react";

export function renderEDocumentStatusOffCanvasTrigger<T>(
  item: T & {
    edocument_status_payload?: string | null | undefined,
    /**
     * Notas de credito diferidas: payload del ATV guardado y todavia sin enviar. Llega
     * como string desde GraphQL y como booleano desde Meili, que solo indexa el flag.
     */
    pending_submission?: string | boolean | null | undefined,
  },
  /**
   * Documento al que pertenece la fila. Sin el, el offcanvas sigue mostrando el mensaje del
   * ATV pero no el diagnostico del rechazo, que necesita releer las lineas del documento.
   */
  documentReference?: EDocumentStatusReference | null
): ReactNode {
  let payload: EDocumentStatusProps | null = null;
  let label;
  const documentStatus = resolveEDocumentAtvStatus(item.edocument_status_payload);
  const parsed = parseEDocumentStatusPayload(item.edocument_status_payload);
  if (!parsed) {
    // Una nota con `pending_submission` no es que Hacienda no haya contestado: es que
    // todavia no se le envio, porque espera a que se registre la factura que referencia.
    label = item.pending_submission
      ? "Pendiente de envio (esperando la factura)"
      : "Pendiente Respuesta"
  } else {
    payload = {
      status: parsed.status ?? "",
      message: parsed.message ?? "",
    }
    if (documentStatus == "rechazado") {
      label = "Rechazada"
    } else if (documentStatus == "aceptado") {
      label = "Aceptada"
    }
  }

  return (<EDocumentStatusOffCanvas payload={payload} documentStatus={documentStatus} documentReference={documentReference}>
    {label}
  </EDocumentStatusOffCanvas>)
}
